import React from 'react'
import { Modal } from 'react-bootstrap'
import EmailComposeForm from './EmailComposeForm.component'
import './EmailSender.css'

type EmailSenderProps = {
  show: boolean
  onHide: () => void
  recipientEmail: string
  modalTitle?: string
  initialSubject?: string
  initialBody?: string
  initialTo?: string[]
  initialCc?: string[]
  initialBcc?: string[]
  backdropClassName?: string
  customClassName?: string
}

const EmailSender: React.FC<EmailSenderProps> = ({
  show,
  onHide,
  recipientEmail,
  modalTitle = 'Email sender',
  initialSubject,
  initialBody,
  initialTo,
  initialCc,
  initialBcc,
  backdropClassName,
  customClassName,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      className={['email-sender-modal-width', customClassName]
        .filter(Boolean)
        .join(' ')}
      backdropClassName={backdropClassName}
      centered
    >
      <Modal.Header
        closeButton
        className="bg-custom3 email-sender-modal-header"
      >
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="email-sender-modal-body p-0">
        <EmailComposeForm
          show={show}
          recipientEmail={recipientEmail}
          initialSubject={initialSubject}
          initialBody={initialBody}
          initialTo={initialTo}
          initialCc={initialCc}
          initialBcc={initialBcc}
          modalTitle={modalTitle}
          variant="modal"
          onClose={onHide}
          onSendSuccess={onHide}
        />
      </Modal.Body>
    </Modal>
  )
}

export default EmailSender
